import { SadPage } from "../../../components/SadPage"

type Props = {
  kioskMode?: boolean
}

export function TooManyRequestsPage({ kioskMode }: Props) {
  return (
    <SadPage
      kioskMode={kioskMode}
      lines={["Too many requests.", "Please wait a moment and try again."]}
    />
  )
}
